import Vue from "vue";
import Antd from 'ant-design-vue';
import axios from 'axios';
import router from './router'

import 'ant-design-vue/dist/antd.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/src/jquery.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import AuthPlugin from "./plugins/AuthPlugin"
import CommonComponents from "./plugins/CommonComponents"
import { handleDates } from "./Utilities/Interceptors.js"

function validateApiUrl(api) {
  if (!api.endsWith('/'))
    return api += '/';

  if (!api.endsWith('api/'))
    return api += 'api/';

  return api;
}

Vue.prototype.$landingPage = 'instances';
Vue.prototype.$loginPage = 'login';
Vue.use(Antd);
Vue.use(AuthPlugin);
Vue.use(CommonComponents);
Vue.config.productionTip = false;
Vue.prototype.$domain = validateApiUrl(process.env.VUE_APP_API);
Vue.prototype.$skipPaymentKey = process.env.VUE_APP_SKIP_PAYMENT_KEY;
Vue.prototype.$skipPaymentChannelKey = process.env.VUE_APP_SKIP_PAYMENT_CHANNEL_KEY;

// axios setup
axios.defaults.baseURL = Vue.prototype.$domain;
axios.defaults.headers.get['Accept'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.interceptors.response.use(originalResponse => {
  handleDates(originalResponse.data);
  return originalResponse;
}, error => {
  if (error == 'Error: Network Error') {
    Vue.prototype.$logoutUser();
  }
  else if (error.response.status === 401) {
    if (router.currentRoute.name !== Vue.prototype.$loginPage) {
      Vue.prototype.$logoutUser();
      return Promise.reject("Unauthorized: Redirect to login");
    }
  }

  return Promise.reject(error);
});
